import { doc, onSnapshot } from 'firebase/firestore'
import { useEffect, useState } from 'react'
import { db, getDocs } from 'utils'

export function getWorkspaces(userId?: string) {
  return getDocs({
    collection: 'Workspace',
    constraints: [
      { field: 'scope', op: '==', value: 'emp' },
      { field: 'isArchived', op: '==', value: false },
      ...(userId
        ? [{ field: 'userIds' as const, op: 'array-contains' as const, value: userId }]
        : []),
    ],
  })
}

export interface GlobalConfiguration {
  minAppVersion: string
}

export function useConfiguration() {
  const documentRef = doc(db, 'globalConfiguration', 'desktop')
  const [config, setConfig] = useState<GlobalConfiguration>()

  useEffect(() => {
    const unsubscribe = onSnapshot(documentRef, snap =>
      setConfig(snap.data() as GlobalConfiguration)
    )

    return () => unsubscribe()
  }, [])

  return config
}
